import React from 'react';
import './JobCategory.css';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';

function JobCategory() {
  return (
    <div className='category'>
      <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.6.0/css/all.min.css" integrity="sha512-Kc323vGBEqzTmouAECnVceyQqyqdsSiqLQISBL29aUW4U/M7pSPA/gEUZQqv1cwx4OnYxTxve5UMg5GT6L4JJg==" crossOrigin="anonymous" referrerPolicy="no-referrer" />
      <Helmet>
        <link
          rel="stylesheet"
          href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.4/css/all.min.css"
        />
      </Helmet>
      <div className="category-container">
        <div className="category-head">
          <h1>Job Category</h1>
          <p>Lorem Ipsum is simply dummy text printing and type setting industry Lorem Ipsum been industry standard dummy text ever since when unknown printer took a galley.</p>
        </div>
        <div className="item-head">
          <div className="grid-container">
            {Array.from({ length: 4 }).map((_, index) => (
              <div className="grid-item" key={index}>
                <Link className='Link1' to="/error">
                  <div className="item-category">
                    <div className="cate-icon">
                      <i className={index === 0 ? "far fa-address-card" : index === 1 ? "fas fa-car" : index === 2 ? "fas fa-tools" : "fas fa-bus"}></i>
                    </div>
                    <div className="catebox-content">
                      <h3>{index === 0 ? "Driver" : index === 1 ? "Delivery" : index === 2 ? "Copper Brazing" : "Bus Driver"}</h3>
                      <p>{index === 0 ? "100 jobs" : index === 1 ? "50 jobs" : index === 2 ? "20 jobs" : "25 jobs"}</p>
                    </div>
                  </div>
                </Link>
              </div>
            ))}
  </div>
</div>
      </div>
      <footer id="footer">
            <div className="footer-content d-flex">
              <div className="contact-section">
                <div className="logo-section d-flex">
                  <div className="company-logo-detail">
                    {/* <a href="#/"><img src="/images/logo.png" alt="" srcset=""></a> */}
                  </div>
                  <div className="company-name-detail">
                    <h5>Better Job Placement</h5>
                  </div>
                </div>
                <div className="number-section">
                  <h5>Call us</h5>
                  <p><a href="#/"><i className="phone fa-solid fa-phone-volume" />9895898502</a><br />
                    <a href="#/"><i className="whatsapp fa-brands fa-whatsapp" />9895898507</a><br/>
                    <a href="#/" className="email">betterplacementmanjeri@gmail.com</a></p>
                </div>
                <p className="address">
                  NAZ MALL, KARAKKUNNU JN<br />
                  MANJERI<br />
                </p>
              </div>
              <div className="link-section d-flex">
                <div className="candidate-section">
                  <h4 className="widget-title">For Candidates</h4>
                  <div className="widget-content">
                    <ul className="jobDetaillist">
                      <li><a href="#/">Browse Jobs</a></li>
                      <li><a href="#/">Browse Categories</a></li>
                      <li><a href="#/">Candidate Dashboard</a></li>
                      <li><a href="#/">Job Alerts</a></li>
                      <li><a href="#/">My Bookmarks</a></li>
                    </ul>
                  </div>
                </div>
                <div className="candidate-section">
                  <h4 className="widget-title">For Employers</h4>
                  <div className="widget-content">
                    <ul className="jobDetaillist">
                      <li><a href="#/">Browse Candidates</a></li>
                      <li><a href="#/">Employer Dashboard</a></li>
                      <li><a href="#/">Add Job</a></li>
                      <li><a href="#/">Job Packages</a></li>
                    </ul>
                  </div>
                </div>
                <div className="candidate-section">
                  <h4 className="widget-title">About Us</h4>
                  <div className="widget-content">
                    <ul className="jobDetaillist">
                      <li><a href="#/">About Us</a></li>
                      <li><a href="#/">Job Page Invoice</a></li>
                      <li><a href="#/">Terms Page</a></li>
                      <li><a href="#/">Blog</a></li>
                      <li><a href="#/">Contact</a></li>
                    </ul>
                  </div>
                </div>
                <div className="candidate-section">
                  <h4 className="widget-title">Helpful Resources</h4>
                  <div className="widget-content">
                    <ul className="jobDetaillist">
                      <li><a href="#/">Site Map</a></li>   
                      <li><a href="#/">Terms of Use</a></li>
                      <li><a href="#/">Privacy Center</a></li>
                      <li><a href="#/">Security Center</a></li>
                      <li><a href="#/">Accessibility Center</a></li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            {/* <div className="footer-bottom">
              <div className="copyright-wrap">
                Copyright© 2024 Future Consultancy Ltd. All Rights Reserved.
              </div>
            </div> */}
          </footer>
    </div>
  );
}

export default JobCategory;
